import { useState } from "react";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { buildSearchQuery, createUUID } from "@miplatform/utils";

const getContactUUID = createUUID();
const updateContactStatusUUID = createUUID();

export const useManageContactViewModel = () => {
  const [contacts, setContacts] = useState([]);
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const getContacts = (search) => {
    stateManager.abort(getContactUUID);
    stateManager.run(async () => {
      const searchQuery = buildSearchQuery(search, [
        "firstName",
        "lastName",
        "displayName",
        "email",
      ]);
      const response = await accountService.contacts.getAll({
        filters: { or: { ...searchQuery } },
        sort: "firstName asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setContacts(response.data);
      }
    }, getContactUUID);
  };

  const updateContactStatus = (data, status) => {
    const { accountId, id } = data;
    stateManager.abort(updateContactStatusUUID);
    return stateManager.run(
      async () =>
        accountService.contacts.update({
          id,
          data: {
            ...data,
            accountId,
            status,
          },
          toastMessageConfig: {
            success: {
              text: `Contact status was updated successfully.`,
            },
          },
        }),
      updateContactStatusUUID
    );
  };

  return {
    isLoading,
    contacts,
    getContacts,
    updateContactStatus,
  };
};
